import { AppStore } from './../../../../core/state/app-store';
import { VehiclesService } from './../../../../core/vehicles.service';
import { DropdownOption } from './../../../../models/dropdown-option';
import { Position } from './../../../../models/api/vehicle-position.model';
import { AppSelector } from './../../../../core/state/app-selector';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ReportsService } from '../../../core/reports.service';
import { PermissionsService } from '../../../../core/permissions.service';
import { ReportOptionsService } from '../report-options.service';
import { map, take, tap } from 'rxjs/operators';

@Component({
  selector: 'app-vehicle-type-selector',
  templateUrl: './vehicle-type-selector.component.html',
  styleUrls: ['./vehicle-type-selector.component.scss'],
})
export class VehicleTypeSelectorComponent implements OnInit {
  @Input() selectedVehicleTypeId: number;
  @Input() findDefaultTypeForUser: boolean;
  @Input() reportId: number;
  @Input() dropdownClass: string = 'dropdown--gray';
  @Input() dropdownIconClass: string = 'fa fa-chevron-down';
  @Output() selectedVehicleTypeIdChange = new EventEmitter<number>();

  vehicleTypes: DropdownOption[];
  selectedVehicleType: any;
  vehicleTypesIsLoading = true;

  constructor(
    private reportsService: ReportsService,
    public permissionsService: PermissionsService,
    private reportOptionsService: ReportOptionsService,
    private vehiclesService: VehiclesService,
    private appSelector: AppSelector,
    private appStore: AppStore
  ) {
    this.vehicleTypesIsLoading = false;
    this.vehicleTypes = this.vehiclesService.vehicleTypesOptions;
  }

  ngOnInit() {
    if (this.selectedVehicleTypeId) {
      this.selectTypeById();
    } else if (
      this.appStore.getState().filterVehicles &&
      this.appStore.getState().filterVehicles.type
    ) {
      this.selectTypeByFilterSelection();
    } else if (this.findDefaultTypeForUser) {
      this.selectDefaultTypeForUser();
    }

    if (!this.selectedVehicleType) {
      this.selectedVehicleType = this.vehicleTypes[0];
    }
  }

  private selectTypeByFilterSelection() {
    let vehicleType = this.vehicleTypes.find(
      (typeOfVehicle) =>
        typeOfVehicle.value ==
        this.appStore.getState().filterVehicles.type.toString()
    );
    if (vehicleType) {
      this.selectedVehicleType = vehicleType;
      this.onSelectedVehicleTypeIdChange();
    }
  }

  private selectDefaultTypeForUser() {
    this.appSelector
      .getSelectedVehicle()
      .pipe(
        take(1),
        map((position: Position) => {
          if (position) {
            return position.vehicle;
          }
        })
      )
      .subscribe((globalSelectedVehicleId) => {
        this.reportsService
          .getVehicles(this.reportId)
          .pipe(
            tap((data) => {
              if (globalSelectedVehicleId)
                this.selectedVehicleType = this.vehicleTypes.find(
                  (typeOfVehicle) => {
                    const selectedVehicle = data.find(
                      (vehicle) => vehicle.id == globalSelectedVehicleId
                    );
                    return (
                      selectedVehicle &&
                      selectedVehicle.typeId == typeOfVehicle.value
                    );
                  }
                );
              if (
                !this.selectedVehicleType ||
                this.selectedVehicleType.value == 0
              ) {
                this.selectedVehicleType = this.vehicleTypes.find(
                  (typeOfVehicle) => {
                    return data.find(
                      (vehicle) => vehicle.typeId == typeOfVehicle.value
                    );
                  }
                );
              }
              this.onSelectedVehicleTypeIdChange();
            })
          )
          .subscribe();
      });
  }

  private selectTypeById() {
    let vehicleType = this.vehicleTypes.find(
      (typeOfVehicle) =>
        typeOfVehicle.value == this.selectedVehicleTypeId.toString()
    );
    if (vehicleType) {
      this.selectedVehicleType = vehicleType;
      this.onSelectedVehicleTypeIdChange();
    }
  }

  onSelectedVehicleTypeIdChange() {
    if (this.selectedVehicleType) {
      this.selectedVehicleTypeIdChange.emit(this.selectedVehicleType.value);
      this.reportOptionsService.typeName = this.selectedVehicleType.label;
      this.reportsService.filterByVehicleTypeId.next(
        this.selectedVehicleType.value
      );
    } else {
      this.selectedVehicleTypeIdChange.emit(0);
      this.reportsService.filterByVehicleTypeId.next(0);
    }
  }
}
